// extracted by mini-css-extract-plugin
export default {"modal":"modal__SGSJJ","transaction":"transaction__sBU7k","transaction__actor":"transaction__actor__hiqHm","amount":"amount__RUk7r","selectField":"selectField__CihZ2"};